import { medicationNdcs } from "src/constants/medications";

export const getReadMoreSlugByNdc = (ndc: string): string | undefined => {
  return Object.keys(medicationNdcs).find((key) =>
    medicationNdcs[key].includes(ndc)
  );
};
